function getHost() {
  let host = document.location.protocol + '//' + window.location.host;
  if (host.indexOf('127') != -1 || host.indexOf('localhost') != -1 || host.indexOf('192') != -1) {
    // host = 'http://cxedu.lc.com';
    // host = 'http://cxedu.xqp.com';
    // host = 'http://39.106.227.60';
    // host = 'http://cxedu.siguedu.com/';
    host = 'http://www.cxedu.org.cn';
  }
  // host = "http://jiaoyu.dy.com";
  return host;
}

getHost();

export default {
  domain: window.location.host,
  rootUrl: getHost(),
  baseURL: getHost(),
  timeout: 30000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  getHost
}



// WEBPACK FOOTER //
// ./src/lib/http/config.js